import { createFileRoute } from '@tanstack/react-router';
import { RoutePlaceholder } from './-components/RoutePlaceholder';

export const Route = createFileRoute('/poker')({
  component: () => <RoutePlaceholder icon="card" title="Poker" description="Poker client entry." />,
});
